import { useMemo, useState } from 'react';
import { InfoIcon } from '@rsos/assets/icons';
import { CheckBox } from '@rsos/components/capstone/base';
import { DropdownButton } from '../DropdownDownload/DropdownButton';
import {
  TableHeaderCell,
  TableHeader as Header,
  TextIcon,
  CustomToolTip,
  TooltipChild,
  HeadersText,
} from '../styles/CommunicationHistoryTable.styles';
import { SortIconWrapper } from './SortIconWrapper';

const REMAINING_DAYS_TOOLTIP_WIDTH = '247px';

export const CommunicationHistoryTableHeader = ({
  isSelectedAllChecked,
  toggleSelectAll,
  checkedList,
  onDownloadClicked,
  handleSortingTextHistory,
  isReversed,
}) => {
  const [isDownloadDropdownVisible, setIsDownloadDropdownVisible] =
    useState(false);
  const hasAnyCheckedBox = useMemo(
    () => Object.values(checkedList).some(val => val === true),
    [checkedList],
  );

  const showDropdown = (onClick = () => {}) => {
    setIsDownloadDropdownVisible(true);
    onClick();
  };

  const handleHeaderClick = isReversed => {
    handleSortingTextHistory(isReversed);
  };
  return (
    <Header>
      <TableHeaderCell>
        <CheckBox
          type="checkbox"
          noText
          name={'all'}
          isChecked={isSelectedAllChecked}
          onChange={toggleSelectAll}
        />
      </TableHeaderCell>

      <TableHeaderCell>
        <TextIcon ellipsis>
          <HeadersText>Phone Number</HeadersText>
        </TextIcon>
      </TableHeaderCell>
      <TableHeaderCell>
        <TextIcon
          ellipsis
          clickable
          onClick={() => handleHeaderClick(isReversed)}
        >
          <HeadersText>Start Time</HeadersText>
          <SortIconWrapper isReversed={isReversed} />
        </TextIcon>
      </TableHeaderCell>
      <TableHeaderCell>
        <TextIcon ellipsis>
          <HeadersText>Duration</HeadersText>
        </TextIcon>
      </TableHeaderCell>
      <TableHeaderCell>
        <TextIcon ellipsis>
          <HeadersText>Remaining Days</HeadersText>
        </TextIcon>
        <CustomToolTip>
          <TooltipChild width={REMAINING_DAYS_TOOLTIP_WIDTH}>
            This is the number of days remaining that RapidSOS will store your
            conversations before permanently deleting them.
          </TooltipChild>
          <InfoIcon width={14} height={14} color="primaryText" />
        </CustomToolTip>
      </TableHeaderCell>
      <TableHeaderCell p={0}>
        <DropdownButton
          isDownloadDropdownVisible={isDownloadDropdownVisible}
          hasAnyCheckedBox={hasAnyCheckedBox}
          onDownloadClicked={onDownloadClicked}
          setIsDownloadDropdownVisible={setIsDownloadDropdownVisible}
          showDropdown={showDropdown}
        />
      </TableHeaderCell>
    </Header>
  );
};
